import { render, staticRenderFns } from "./InputListProjectArea.vue?vue&type=template&id=5656a684&scoped=true"
import script from "./InputListProjectArea.vue?vue&type=script&lang=js"
export * from "./InputListProjectArea.vue?vue&type=script&lang=js"
import style0 from "./InputListProjectArea.vue?vue&type=style&index=0&id=5656a684&prod&scoped=true&lang=css"
import style1 from "./InputListProjectArea.vue?vue&type=style&index=1&id=5656a684&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656a684",
  null
  
)

export default component.exports